import React from 'react';
import { Button, message } from 'antd';
import { Download } from 'lucide-react';
import { InvoiceV2 } from '@/store/invoice/useGetInvoicesV2';
import { useInvoiceMutation } from '@/store/invoice/useInvoiceLink';
import * as S from '../styled';

type Props = Pick<InvoiceV2, 'barcode' | 'code'>;

export function PdfCell({ barcode, code }: Props) {
    const { mutateAsync, isLoading } = useInvoiceMutation();

    if (!barcode) return <S.Muted>—</S.Muted>;

    const download = async () => {
        try {
            const response = await mutateAsync({ code, barcode });
            window.open(response.link);
        } catch (err) {
            message.error(
                'Ops, Aconteceu algo de errado, tente novamente mais tarde.',
            );
        }
    };

    return (
        <Button
            type="link"
            size="small"
            icon={<Download size={14} />}
            onClick={download}
            loading={isLoading}
        >
            Baixar
        </Button>
    );
}
